
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ordbog",
      function () {
        return require("private-next-pages/ordbog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ordbog"])
      });
    }
  